module.exports = __webpack_public_path__ + "static/media/shop.ba103289.svg";